import Util from '@/helper/Utility.js';
import { DropdownListValue } from '@/helper/FormHelper'
import DatetimeHelper from '@/helper/DatetimeHelper';

export function RegisterModel() {
    this.prefix = null;
    this.firstName = null;
    this.lastName = null;
    this.tel = null;
    this.birthdate = null;
    this.email = null;
    this.termsVersion = 1;
    this.privacyVersion = 1;
    this.marketingVersion = 1;
    this.isAcceptMarketing = 0;
    this.otpModel = {
        otp: null,
        refcode: null,
        channel: null,
    }
    this.password = null;
    this.confirmPassword = null;
    this.isFacebookRegister = false;
    this.isGoogleRegister = false;
    this.isLoadGoogle = false;

    this.getParamsValidateRegister = function () {
        let params = {
            username: this.tel,
            email: this.email,
            contact_number: this.tel,
        };

        return params;
    };

    this.setPassword = function (pass) {
        this.password = pass;
    };
    this.setConfirmPassword = function (pass) {
        this.confirmPassword = pass;
    };

    this.setTerms = function (terms) {
        this.termsVersion = terms;
    };
    this.setPrivacy = function (privacy) {
        this.privacyVersion = privacy;
    };
    this.setMarketing = function (marketing) {
        this.marketingVersion = marketing;
    };
    this.setAcceptMarketing = function (accept) {
        if (accept) {
            this.isAcceptMarketing = this.marketingVersion
        }
    };
    this.setAcceptTermsAndPrivacy = function (accept) {
        if (accept) {
            this.isAcceptMarketing = this.marketingVersion
        }
        if (!accept) {
            this.termsVersion = 0;
            this.privacyVersion = 0;
        }
    }

    /**
     * @param {OtpModel} otpModel /core/Account/model/OtpModel.js
     */
    this.setOtpModel = function (otpModel) {
        this.otpModel.otp = otpModel.otp;
        this.otpModel.refcode = otpModel.refcode;
        this.otpModel.channel = otpModel.channel;
    };

    this.setValueFromCache = function (cache) {
        this.prefix = cache.prefix;
        this.firstName = cache.firstName;
        this.lastName = cache.lastName;
        this.tel = cache.tel;
        this.email = cache.email;
        this.termsVersion = cache.termsVersion;
        this.privacyVersion = cache.privacyVersion;
        this.marketingVersion = cache.marketingVersion;
        this.isAcceptMarketing = cache.isAcceptMarketing;
        this.isFacebookRegister = cache.isFacebookRegister;
        this.isGoogleRegister = cache.isGoogleRegister;
        this.isLoadGoogle = cache.isLoadGoogle;

        this.otpModel = {
            otp: cache.otpModel.otp,
            refcode: cache.otpModel.refcode,
            channel: cache.otpModel.channel,
        }

        if (cache.birthdate != null) {
            this.birthdate = new Date(cache.birthdate);
        }
    };

    this.getParams = function () {
        let birthdateConvert = null;
        if (this.birthdate) {
            birthdateConvert = DatetimeHelper.convertDateToTimeStampUnix(this.birthdate)
        }
        let params = {
            username: this.email,
            password: this.password,
            confirmpassword: this.confirmPassword,
            email: this.email,
            title: this.prefix,
            firstname: this.firstName,
            lastname: this.lastName,
            contact_number: this.tel,
            birthdate: birthdateConvert,
            termandcondition: this.termsVersion,
            dataprivacy: this.privacyVersion,
            marketingoption: this.isAcceptMarketing,
            otp: this.otpModel.otp,
            refcode: this.otpModel.refcode,
        };

        return Util.cleanObjectEmptyStr(params);
    };

}

export const RegisterFormInit = {
    genPrefix: function () {
        let list = new DropdownListValue();
        list.add('Mr.', 'mr');
        list.add('Ms.', 'ms');
        list.add('Mrs.', 'mrs');
        return list.getList();
    },
}
